import angular from 'angular';
import moment from "angular-moment";

import chartConfig from './power-stat-graph-event.config';

export class PowerStatGraphEventController {
  /*@ngInject*/
  constructor($scope, $filter, $interval, moment) {
    this.chartConfig = chartConfig(this);
    this.moment = moment;
    this.$filter = $filter;
    this.$interval = $interval;
    $scope.$watch('$ctrl.data.events', newValue => this.updateGraph(newValue, this.data.targetDate));
    $scope.$watch('$ctrl.data.type', () => this.reflowGraph());
  }

  $onInit() {
    this.updateGraph(this.data.events, this.data.targetDate);
  }

  updateGraph(eventData, targetDate) {
    if (!eventData || !this.chart) {
      return;
    }
    const graphData = this.createGraphData(eventData.current, targetDate);
    this.chart.series[0].setData(graphData);
    this.chart.reflow();
  }

  reflowGraph() {
    if (!this.chart) {
      return;
    }
    this.$interval(() => {
      this.chart.redraw();
      this.chart.reflow();
    }, 100);
  }

  createGraphData(events, targetDate) {
    const startDate = targetDate.clone().startOf('month');
    const endDate = targetDate.clone().endOf('month');

    const eventCounts = [];
    const numberOfDays = endDate.diff(startDate, 'days');

    for(let i = 0; i <= numberOfDays; i++) {
      eventCounts.push({ x: startDate.valueOf(), y: 0 });
      startDate.add(1, 'day');
    }

    for(let event of events) {
      if (!event.event_tag.match(/.*_exceeded/)) {
        continue;
      }

      const date = this.moment(event.occurred_at).startOf('day').valueOf();
      const countObject = eventCounts.find(e => e.x === date);
      if (countObject) {
        countObject.y += 1;
      }
    }
    return eventCounts;
  }
}

export default angular.module('leptonApp.powerStatGraphEvent', [moment])
  .component('powerStatGraphEvent', {
    template: '<chart value="$ctrl.chartConfig"></chart>',
    controller: PowerStatGraphEventController,
    bindings: {
      data: '='
    }
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/statistics_report/power-stat-graph/event/power-stat-graph-event.component.js